import React, { useState } from 'react';
import { Toaster } from 'react-hot-toast';
import ErrorLogViewer from './ErrorLogViewer';
import Sidebar from './Sidebar';
import { useAuth } from '../hooks/useAuth';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { isAuthenticated } = useAuth();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900">
      {isAuthenticated ? (
        <div className="flex min-h-screen">
          {/* Sidebar */}
          <Sidebar isOpen={sidebarOpen} onToggle={() => setSidebarOpen(!sidebarOpen)} />
          
          {/* Main Content */}
          <main className="flex-1 transition-all duration-300">
            {children}
          </main>
        </div>
      ) : (
        /* Content without sidebar */
        <main className="min-h-screen">
          {children}
        </main>
      )}
      
      {/* Toaster */}
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#1f2937',
            color: '#fff',
            border: '1px solid #374151',
          },
          success: {
            iconTheme: {
              primary: '#10b981',
              secondary: '#fff',
            },
          },
          error: {
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
      
      {/* Error Log Viewer */}
      <ErrorLogViewer />
    </div>
  );
};

export default Layout;
